<template>
  <RcContentSplit>
    <template #content-left>
      <img
        src="/src/assets/img/illustrations/rhino_searching_combined.svg"
        class="rc-rhino-searching-combined rc-illustration"
        alt=""
    /></template>
    <template #content-right>
      <div class="rc-subscriber-getStarted">
        <template v-if="$route.name == 'subscribers.orphan'">
          <h1>{{ $t("auth.get_started.orphan.title") }}</h1>
          <div class="rc-intro">
            <p v-orphan>
              {{ $t("auth.get_started.orphan.intro") }}
            </p>
          </div>
        </template>
        <template v-else>
          <h1 v-html="$t('auth.get_started.title')"></h1>
          <div class="rc-intro">
            <p v-html="$t('auth.get_started.intro')"></p>
          </div>
        </template>

        <RcSubscriberVerify />
        <div class="rc-divider-or">
          <div class="rc-divider-or--line"></div>
          <div class="rc-divider-or--text">{{ $t("common.or") }}</div>
          <div class="rc-divider-or--line"></div>
        </div>

        <rc-btn
          size="lg"
          variant="outline-secondary"
          class="rc-btn-access-point mx-auto"
          data-bs-toggle="modal"
          data-bs-target="#findAccessModal"
        >
          <RcIcon name="geoFill" scale="1.5"></RcIcon>
          {{ $t("auth.access_points.find") }}</rc-btn
        >
        <RcFindAccessModal />
      </div>
    </template>
  </RcContentSplit>
</template>

<script>
import Config from "#/config";
import RcContentSplit from "#/layout/components/ContentSplit.vue";
import RcIcon from "@/libvue/components/icons/Base.vue";
import { navMixin } from "#/routes/mixins";
import RcSubscriberVerify from "#/pages/subscribers/components/SubscriberVerify.vue";
import RcFindAccessModal from "#/pages/onboard/components/FindAccessModal.vue";

export default {
  name: "RcSiteGetStarted",
  components: {
    RcContentSplit,
    RcSubscriberVerify,
    RcFindAccessModal,
    RcIcon
  },
  mixins: [navMixin],

  data() {
    return {
      apiHost: Config.apiHost()
    };
  },

  computed: {
    geoLoc() {
      return window.geoip_region();
    }
  }
};
</script>
<style lang="scss"></style>
